export default __webpack_public_path__ + "static/media/upload.cfd3a50a.gif";